module.exports = __webpack_public_path__ + "static/media/romy-hero-blurred.b720326b.png";